import CodeForm from './CodeForm'
import NotePanel from './NotePanel'

const Selector = ({ t, setCodeType, user }) => (
  <div className="immob-panel">
    <p className="immob-subtitle">{t('common:pats-selector-subtitle')}</p>

    <div className="immob-cards">
      <div className="immob-card immob-card--primary">
        <div className="immob-card-bar" />
        <div className="immob-card-body">
          <span className="immob-eyebrow">{t('common:pats-eyebrow-codeword')}</span>
          <h3 className="immob-card-title">{t('common:pats-page-content-12')}</h3>
          <p className="immob-used-for">{t('common:pats-used-for')}</p>
          <ul className="immob-veh-list">
            <li>{t('common:pats-codeword-veh-1')}</li>
            <li>{t('common:pats-codeword-veh-2')}</li>
            <li>{t('common:pats-codeword-veh-3')}</li>
            <li>{t('common:pats-codeword-veh-4')}</li>
          </ul>
          <button className="immob-btn immob-btn--primary" onClick={() => setCodeType('PAT')}>
            {t('common:pats-request-codeword')}
          </button>
        </div>
      </div>

      <div className="immob-card immob-card--serial">
        <div className="immob-card-bar" />
        <div className="immob-card-body">
          <span className="immob-eyebrow immob-eyebrow--muted">{t('common:pats-eyebrow-serial')}</span>
          <h3 className="immob-card-title">{t('common:pats-page-content-11')}</h3>
          <p className="immob-used-for">{t('common:pats-used-for')}</p>
          <ul className="immob-veh-list immob-veh-list--muted">
            <li>{t('common:pats-serial-veh-1')}</li>
            <li>{t('common:pats-serial-veh-2')}</li>
            <li>{t('common:pats-serial-veh-3')}</li>
          </ul>
          <button className="immob-btn immob-btn--secondary" onClick={() => setCodeType('Immob')}>
            {t('common:pats-request-serial')}
          </button>
        </div>
      </div>
    </div>

    <NotePanel t={t} user={user} strip />

    <p className="immob-software-link">
      <a
        href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Mazda_Software_Explained_Before_Purchase.pdf"
        target="_blank"
      >
        {t('common:subscription-common')}
      </a>
    </p>
  </div>
)

const PATSValidSubscription = ({ t, setCodeType, codeType, user, handleResetForm }) => (
  <div className="content m-t-lg immob-codes">
    {codeType ? (
      <CodeForm
        setCodeType={setCodeType}
        codeType={codeType}
        handleResetForm={handleResetForm}
        user={user}
        t={t}
      />
    ) : (
      <Selector t={t} setCodeType={setCodeType} user={user} />
    )}
  </div>
)

export default PATSValidSubscription



// WEBPACK FOOTER //
// ./components/PATSCodes/WithValidSubscription.js